import React, {useEffect, useRef, useState, useCallback} from 'react';
import {NumericFormat} from "react-number-format";
import axios from "axios";
import {baseUrl} from "../../api/network";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import {useShallowPickSelector} from "../../redux";

const Table = ({sendBackData = null, containerClassName}) => {
    const {tgUser} = useShallowPickSelector('user', ['tgUser'])
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef();

    const getItems = async (pageNumber) => {
        return new Promise((resolve) => {
            const headers = {
                'Content-Type': 'application/json',
            }
            axios.get(`${baseUrl}/affiliate/list?user_tg_id=${tgUser?.id}&page=${pageNumber}`, {headers})
                .then(response => {
                    if (response.data.status === '1') {
                        if (sendBackData) {
                            sendBackData(response.data.data)
                        }
                        resolve(response.data.data.items);
                    } else {
                        resolve([]);
                        toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 7});
                    }
                })
                .catch(() => {
                    resolve([]);
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 8});
                })
        });
    };

    const loadMoreItems = useCallback(async () => {
        setLoading(true);
        const newItems = await getItems(page);
        setItems((prevItems) => [...prevItems, ...newItems]);
        setLoading(false);

        if (newItems.length === 0) {
            setHasMore(false);
        }
    }, [page]);

    useEffect(() => {
        if (hasMore) {
            loadMoreItems();
        }
    }, [page, hasMore, loadMoreItems]);

    const lastItemRef = useCallback(
        (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    setPage((prevPage) => prevPage + 1);
                }
            });
            if (node) observer.current.observe(node);
        },
        [loading, hasMore]
    );

    return (
        <div className={`w100 h100 overflow-auto maxH300 ${containerClassName}`}>
            <table cellSpacing={0} className="w100 affiliatePanel-affiliateTable overflow-auto">
                <thead className="text-white">
                <tr>
                    <th>Friends</th>
                    <th>$JETs</th>
                    <th>CPs</th>
                </tr>
                </thead>
                <tbody>
                    {items && items?.map((item, index) => {
                        if (index === items.length - 1) {
                            return (
                                <tr ref={lastItemRef} key={item?.user_tg_id.toString()}>
                                    <td className="text-white center justifyStart minW150 lineNumber1">
                                        <img alt="Jace User" src={item?.profile_img} className="affiliatePanel-userImage" />
                                        <p className="ml10 lineNumber1 maxW150">{item?.tg_username}</p>
                                    </td>
                                    <td className="text-white minW50 lineNumber1">
                                        <NumericFormat
                                            value={item?.current_jets ? `${item?.current_jets}` : 0}
                                            thousandSeparator=","
                                            displayType="text"
                                            title={item?.current_jets ? `${item?.current_jets}` : 0}
                                            className="text-white lineNumber1 wUnset"
                                        />
                                    </td>
                                    <td className="text-white minW50 lineNumber1">
                                        <NumericFormat
                                            value={item?.affiliate_commissions ? `${item?.affiliate_commissions}` : 0}
                                            thousandSeparator=","
                                            displayType="text"
                                            title={item?.affiliate_commissions ? `${item?.affiliate_commissions}` : 0}
                                            className="text-white lineNumber1 wUnset"
                                        />
                                    </td>
                                </tr>
                            )
                        } else {
                            return (
                                <tr key={item?.user_tg_id.toString()}>
                                    <td className="text-white center justifyStart minW150 lineNumber1">
                                        <img alt="Jace User" src={item?.profile_img} className="affiliatePanel-userImage" />
                                        <p className="ml10 lineNumber1 maxW150">{item?.tg_username}</p>
                                    </td>
                                    <td className="text-white minW50 lineNumber1">
                                        <NumericFormat
                                            value={item?.current_jets ? `${item?.current_jets}` : 0}
                                            thousandSeparator=","
                                            displayType="text"
                                            title={item?.current_jets ? `${item?.current_jets}` : 0}
                                            className="text-white lineNumber1 wUnset"
                                        />
                                    </td>
                                    <td className="text-white minW50 lineNumber1">
                                        <NumericFormat
                                            value={item?.affiliate_commissions ? `${item?.affiliate_commissions}` : 0}
                                            thousandSeparator=","
                                            displayType="text"
                                            title={item?.affiliate_commissions ? `${item?.affiliate_commissions}` : 0}
                                            className="text-white lineNumber1 wUnset"
                                        />
                                    </td>
                                </tr>
                            )
                        }
                    })}
                    {loading && (
                        <tr>
                            <td colSpan={6}>
                                <div className="w100 center">
                                    <div className="loader"></div>
                                </div>
                            </td>
                        </tr>
                    )}
                    {!loading && items.length < 1 && (
                        <tr>
                            <td colSpan={6}>
                                <p className="center text-[#6A6D7D]">Nothing To Show</p>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default Table;
